import { gql } from '@apollo/client';

export const GET_PROJECT_USERS = gql`
    query ProjectUsers($projectId: Int!) {
        projectUsers(projectId: $projectId) {
                id
                name
                email
                role_id
                role {
                    id
                    role_type
                }
                project_user_id
            }
        }
`;

export const GET_UNASSIGNED_PROJECT_USES = gql`
  query ProjectUnAssignedUsers($projectId: Int!) {
    projectUnAssignedUsers(projectId: $projectId) {
            id
            name
            email
            role_id
            role {
                id
                role_type
            }
        }
    }
`;

export const Add_USERS_TO_PROJECTS = gql`
    mutation AddProjectUsers($userIds: [Int!]!, $projectId: Int!) {
        addProjectUsers(user_ids: $userIds, projectId: $projectId)
    }
`;

export const REMOVE_USER_FROM_PROJECTS = gql`
    mutation DeleteProjectUser($projectUserId: Int!) {
        deleteProjectUser(projectUserId: $projectUserId)
    }
`;
